import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

const rootElement = document.getElementById('root') as HTMLElement;

const AppTree = (
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <HelmetProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
    </I18nextProvider>
  </React.StrictMode>
);

// react-snap önceden HTML render ettiyse hydrate et (SEO botları için statik HTML korunur).
// Normal ziyaretçilerde ise sıfırdan createRoot ile mount edilir.
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, AppTree);
} else {
  ReactDOM.createRoot(rootElement).render(AppTree);
}

reportWebVitals();

